import { post, type APIRequestBody, type APIResponse } from './base-fetch';

export type PinnedItem = APIResponse<'/api/v4/pinned-items/toggle'>;

export type TogglePinnedItemPayload =
  APIRequestBody<'/api/v4/pinned-items/toggle'>;

export const togglePinnedItem = async (data: TogglePinnedItemPayload) =>
  post<PinnedItem, TogglePinnedItemPayload>('v4/pinned-items/toggle', data);
